import { render, staticRenderFns } from "./vue-tinymce.vue?vue&type=template&id=5af199f8"
import script from "./vue-tinymce.vue?vue&type=script&lang=js"
export * from "./vue-tinymce.vue?vue&type=script&lang=js"
import style0 from "./vue-tinymce.vue?vue&type=style&index=0&id=5af199f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports